import styled from '@emotion/styled';
import { Skeleton, TableCell, TableRow } from '@mui/material';
import { QcsPaper } from '../../common/basic/QcsPaper';

const SCROLL_AREA_RADIUS = '12px';
export const LOADING_SKELETON_HEIGHT = 320;

export const TableRoot = styled(QcsPaper)({
  padding: 0,
  borderRadius: '16px',
  display: 'flex',
  flexDirection: 'column',
});

export const ScrollArea = styled.div({
  overflow: 'auto',
  borderRadius: SCROLL_AREA_RADIUS,
  border: '1px solid rgba(15, 23, 42, 0.08)',
});

export const LoadingSkeleton = styled(Skeleton)({
  borderRadius: SCROLL_AREA_RADIUS,
});

export const StickyHeadCell = styled(TableCell)(({ theme }) => ({
  position: 'sticky',
  top: 0,
  background: '#f8fafc',
  fontWeight: 600,
  color: theme.palette.text.primary,
  zIndex: 1,
}));

export const ClickableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'clickable',
})<{ clickable?: boolean }>(({ clickable }) => ({
  cursor: clickable ? 'pointer' : 'default',
  '&:hover': clickable
    ? {
        background: '#f1f5f9',
      }
    : undefined,
  '& > .MuiTableCell-root': {
    background: 'inherit',
  },
}));

export const TableEmpty = styled.div(({ theme }) => ({
  padding: '2rem 1rem',
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
